import { supabase } from '../lib/supabase';

export const mediaService = {
  async uploadFile(file, userId) {
    const fileExt = file?.name?.split('.')?.pop();
    const fileName = `${Date.now()}-${Math.random()?.toString(36)?.substring(7)}.${fileExt}`;
    const filePath = `${userId}/${fileName}`;

    const { data: uploadData, error: uploadError } = await supabase?.storage?.from('admin-media')?.upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (uploadError) throw uploadError;

    // Track upload in database
    const { data: mediaRecord, error: dbError } = await supabase?.from('media_uploads')?.insert({
        user_id: userId,
        file_name: file?.name,
        file_path: filePath,
        file_size: file?.size,
        mime_type: file?.type,
        bucket_name: 'admin-media'
      })?.select()?.single();

    if (dbError) throw dbError;

    return { uploadData, mediaRecord };
  },

  async getFileUrl(filePath) {
    const { data, error } = await supabase?.storage?.from('admin-media')?.createSignedUrl(filePath, 3600); // 1 hour expiry

    if (error) throw error;
    return data?.signedUrl;
  },

  async getAllMedia() {
    const { data, error } = await supabase?.from('media_uploads')?.select('*')?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  },

  async deleteFile(mediaId, filePath) {
    // Delete from storage
    const { error: storageError } = await supabase?.storage?.from('admin-media')?.remove([filePath]);

    if (storageError) throw storageError;

    // Delete from database
    const { error: dbError } = await supabase?.from('media_uploads')?.delete()?.eq('id', mediaId);

    if (dbError) throw dbError;
  },

  async listFiles(folderPath = '') {
    const { data, error } = await supabase?.storage?.from('admin-media')?.list(folderPath, {
        limit: 100,
        offset: 0,
        sortBy: { column: 'created_at', order: 'desc' }
      });

    if (error) throw error;
    return data;
  }
};